import { render } from "./editarColaborador.vue?vue&type=template&id=7c2c4820&scoped=true"
import script from "./editarColaborador.vue?vue&type=script&lang=js"
export * from "./editarColaborador.vue?vue&type=script&lang=js"

import "./editarColaborador.vue?vue&type=style&index=0&id=7c2c4820&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\reclasin-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2c4820"]])

export default __exports__